export default __webpack_public_path__ + "maps-examples-clustering-with-images-1200-8a14748920cd46de6a511ba20405c809.png";